'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2017/5/22.
                    */

// import Collapse from 'react-collapse';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _HoverComponent = require('../HoverComponent/HoverComponent');

var _HoverComponent2 = _interopRequireDefault(_HoverComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListPageFilterBar = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ListPageFilterBar, _Component);

  function ListPageFilterBar() {
    (0, _classCallCheck3.default)(this, ListPageFilterBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ListPageFilterBar).call(this));

    _this.state = {
      selectedFirstItemId: '',
      selectedSecondItemId: '',
      secondLevelLoad: false,
      secondItemMoreBtnClick: '',
      fourthItemBottomItemsFlipInfo: {},
      thirdHeaderId: '1',
      /*  middleFilterSecondLevel: [{
       'id': 'M0040390000000000000000001',
       'name': '雕塑艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/sort/dsyp.jpg'
       }, {
       'id': 'M0040390000000000000000009',
       'name': '民族工艺',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/sort/mzgy.jpg'
       }, {
       'id': 'M0040390000000000000000005',
       'name': '纤维编织',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/sort/xwbz.jpg'
       }, {
       'id': 'M0040390000000000000000010',
       'name': '陶瓷艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/sort/tcyp.jpg'
       }, {
       'id': 'M0040390000000000000000002',
       'name': '金属艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/sort/jsyp.jpg'
       }, {
       'id': 'M0040390000000000000000004',
       'name': '花画艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/sort/hhyp.jpg'
       }, {
       'id': 'M0040390000000000000000008',
       'name': '珠宝首饰',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/sort/zbyp.jpg'
       }, {
       'id': 'M0040390000000000000000007',
       'name': '地毯挂毯',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/sort/dtgt.jpg'
       }, {
       'id': 'M0040390000000000000000006',
       'name': '抽纱刺绣',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/sort/cscx.jpg'
       }, {
       'id': 'M0040390000000000000000011',
       'name': '书画艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/sort/shyp.jpg'
       }, {
       'id': 'M0040390000000000000000003',
       'name': '漆器艺品',
       'parentId': 'M0043950000000000000000004',
       'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/sort/qqyp.jpg'
       }], */
      middleFilterSecondLevel: [{
        'id': 'M0040390000000000000000003',
        'name': '地毯挂毯',
        'parentId': 'M0043950000000000000000004',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg9.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_9_tx2.png'
      }, {
        'id': 'M0040390000000000000000001',
        'name': '雕塑艺品',
        'parentId': 'M0043950000000000000000004',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg14.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_14_tx.png'
      }, {
        'id': 'M0040390000000000000000009',
        'name': '民族工艺',
        'parentId': 'M0043950000000000000000004',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg18.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_18_tx.png'
      }, {
        'id': 'M0040390000000000000000005',
        'name': '纤维编织',
        'parentId': 'M0043950000000000000000004',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg12.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_12_tx.png'
      }, {
        'id': 'M0040390000000000000000010',
        'name': '陶瓷艺品',
        'parentId': 'M0043950000000000000000004',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg17.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_17_tx.png'
      }, {
        'id': 'M0040390000000000000000002',
        'name': '金属艺品',
        'parentId': 'M0043950000000000000000004',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg19.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_19_tx.png'
      }, {
        'id': 'M0040390000000000000000004',
        'name': '花画艺品',
        'parentId': 'M0043950000000000000000004',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg13.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_13_tx.png'
      }, {
        'id': 'M0040390000000000000000008',
        'name': '珠宝首饰',
        'parentId': 'M0043950000000000000000004',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg11.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_11_tx.png'
      }, {
        'id': 'M0040390000000000000000006',
        'name': '抽纱刺绣',
        'parentId': 'M0043950000000000000000004',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg16.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_16_tx.png'
      }, {
        'id': 'M0040390000000000000000011',
        'name': '书画艺品',
        'parentId': 'M0043950000000000000000004',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg15.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_15_tx.png'
      }, {
        'id': 'M0040390000000000000000007',
        'name': '漆器艺品',
        'parentId': 'M0043950000000000000000004',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg10.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_10_tx2.png'
      }],
      middleFilterFourthLevel: [{
        parentId: 'M0040390000000000000000001',
        topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/diaosugongyi.jpg',
        bottomItems: [{
          id: '1',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/dsyp/1.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg28.png'
        }, {
          id: '2',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/dsyp/2.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg30.png'
        }, {
          id: '3',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/dsyp/3.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg32.png'
        }, {
          id: '4',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/dsyp/4.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg34.png'
        }]
      }, {
        parentId: 'M0040390000000000000000003',
        topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/qiqiyipin.jpg',
        bottomItems: [{
          id: '5',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/qqyp/1.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg36.png'
        }, {
          id: '6',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/qqyp/2.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg38.png'
        }, {
          id: '7',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/qqyp/3.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg40.png'
        }, {
          id: '8',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/qqyp/4.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg42.png'
        }]
      }, {
        parentId: 'M0040390000000000000000009',
        topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/minzugongyi.jpg',
        bottomItems: [{
          id: '9',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/mzgy/1.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg44.png'
        }, {
          id: '10',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/mzgy/2.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg46.png'
        }, {
          id: '11',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/mzgy/3.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg48.png'
        }, {
          id: '12',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/mzgy/4.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg50.png'
        }]
      }, {
        parentId: 'M0040390000000000000000005',
        topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/xianweibianzhi.jpg',
        bottomItems: [{
          id: '13',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/xwbz/1.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg52.png'
        }, {
          id: '14',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/xwbz/2.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg54.png'
        }, {
          id: '15',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/xwbz/3.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg56.png'
        }, {
          id: '16',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/xwbz/4.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg58.png'
        }]
      }, {
        parentId: 'M0040390000000000000000010',
        topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/taociyipin.jpg',
        bottomItems: [{
          id: '17',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/tcyp/1.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg60.png'
        }, {
          id: '18',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/tcyp/2.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg62.png'
        }, {
          id: '19',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/tcyp/3.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg64.png'
        }, {
          id: '20',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/tcyp/4.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg66.png'
        }]
      }, {
        parentId: 'M0040390000000000000000002',
        topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/jinshuyipin.jpg',
        bottomItems: [{
          id: '21',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/jsyp/1.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg68.png'
        }, {
          id: '22',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/jsyp/2.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg70.png'
        }, {
          id: '23',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/jsyp/3.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg72.png'
        }, {
          id: '24',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/jsyp/4.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg74.png'
        }]
      }, {
        parentId: 'M0040390000000000000000004',
        topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/huahuagongyi.jpg',
        bottomItems: [{
          id: '25',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/hhgy/1.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg76.png'
        }, {
          id: '26',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/hhgy/2.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg78.png'
        }, {
          id: '27',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/hhgy/3.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg80.png'
        }, {
          id: '28',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/hhgy/4.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg82.png'
        }]
      }, {
        parentId: 'M0040390000000000000000008',
        topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/zhubaoshoushi.jpg',
        bottomItems: [{
          id: '29',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/zbss/1.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg11.png'
        }, {
          id: '30',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/zbss/2.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg13.png'
        }, {
          id: '31',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/zbss/3.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg15.png'
        }, {
          id: '32',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/zbss/4.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg17.png'
        }]
      }, {
        parentId: 'M0040390000000000000000007',
        topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/ditanguatan.jpg',
        bottomItems: [{
          id: '33',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/dtgt/1.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg11.png'
        }, {
          id: '34',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/dtgt/2.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg13.png'
        }, {
          id: '35',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/dtgt/3.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg15.png'
        }, {
          id: '36',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/dtgt/4.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg17.png'
        }]
      }, {
        parentId: 'M0040390000000000000000006',
        topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/choushacixiu.jpg',
        bottomItems: [{
          id: '37',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/cscx/1.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg11.png'
        }, {
          id: '38',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/cscx/2.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg13.png'
        }, {
          id: '39',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/cscx/3.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg15.png'
        }, {
          id: '40',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/cscx/4.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_bg17.png'
        }]
      }, {
        parentId: 'M004313',
        bottomItems: [{
          id: '41',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img20.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img20_1.png'
        }, {
          id: '42',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img21.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img21_1.png'
        }, {
          id: '43',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img22.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img22_1.png'
        }, {
          id: '44',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img23.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img23_1.png'
        }]
      }, {
        parentId: 'M004257',
        topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/zhubaoshoushi.jpg',
        bottomItems: [{
          id: '45',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img20.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img20_1.png'
        }, {
          id: '46',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img21.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img21_1.png'
        }, {
          id: '47',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img22.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img22_1.png'
        }, {
          id: '48',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img23.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/third/new_pl_img23_1.png'
        }]
      }, {
        parentId: 'M0040390000000000000000011',
        topImg: 'http://tupian.goeasy.cn:9999/yipinwang/third/shuhuayipin.jpg',
        bottomItems: [{
          id: '33',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/shyp/1.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/shyp/5.png'
        }, {
          id: '34',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/shyp/2.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/shyp/6.png'
        }, {
          id: '35',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/shyp/3.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/shyp/7.png'
        }, {
          id: '36',
          front: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/shyp/4.png',
          back: 'http://tupian.goeasy.cn:9999/yipinwang/thirdlevel/shyp/8.png'
        }]
      }]
    };
    return _this;
  }

  (0, _createClass3.default)(ListPageFilterBar, [{
    key: 'onSecondItemMoreBtnClick',
    value: function onSecondItemMoreBtnClick() {
      var secondItemMoreBtnClick = this.state.secondItemMoreBtnClick;

      var currentState = '1';
      if (secondItemMoreBtnClick) {
        currentState = '';
      }
      this.setState({
        secondItemMoreBtnClick: currentState
      });
    }
  }, {
    key: 'onSecondItemClick',
    value: function onSecondItemClick(currentItem) {
      var _props = this.props;
      var secondItemClick = _props.secondItemClick;
      var changeShownOfBelow = _props.changeShownOfBelow;
      var selectedFirstItemId = _props.selectedFirstItemId;

      if (secondItemClick) {
        var sTop = document.documentElement.scrollTop + document.body.scrollTop;
        secondItemClick(selectedFirstItemId, currentItem.id);
        window.scrollTo(0, sTop);
        // onChangeSelectedSecondItemId(currentItem.id);  onChangeSelectedSecondItemId
        this.setState({
          selectedSecondItem: currentItem
        });
      }
      if (changeShownOfBelow) {
        changeShownOfBelow(false);
      }
    }
  }, {
    key: 'fourthBackBtnClick',
    value: function fourthBackBtnClick() {
      var _props2 = this.props;
      var changeShownOfBelow = _props2.changeShownOfBelow;
      var onFourthConstBackBtnClick = _props2.onFourthConstBackBtnClick;

      if (changeShownOfBelow) {
        changeShownOfBelow(true);
      }
      /* onChangeSelectedSecondItemId
       if (onChangeSelectedSecondItemId) {
       onChangeSelectedSecondItemId('');
       }
       */

      if (onFourthConstBackBtnClick) {
        var sTop = document.documentElement.scrollTop + document.body.scrollTop;
        onFourthConstBackBtnClick();
        window.scrollTo(0, sTop);
      }

      this.setState({
        selectedSecondItem: null
      });
    }
  }, {
    key: 'analysisSecondConstDiv',
    value: function analysisSecondConstDiv(isOpened, secondSectionClassName) {
      var _this2 = this;

      var secondLevel = this.state.middleFilterSecondLevel;
      var styles = require('./ListPageFilterBar.scss');
      var secondImgs = [];
      var thirdItemArray = [];
      var leftDiv = _react2.default.createElement('div', null);
      //   <Collapse isOpened={isOpened}>
      secondLevel.forEach(function (currentItem, index) {
        if (index < 6) {
          var currentClassName = styles.img + ' ' + styles.imgSize;
          switch (index) {
            case 1:
              currentClassName = styles.img + ' ' + styles.imgSize + ' ' + styles.imgMarginLeft;
              break;
            case 2:
              currentClassName = styles.img + ' ' + styles.imgSize + ' ' + styles.imgMarginLeft;
              break;
            case 3:
              currentClassName = styles.img + ' ' + styles.imgSize + ' ' + styles.imgMarginTop;
              break;
            case 4:
              currentClassName = styles.img + ' ' + styles.imgSize + ' ' + styles.imgMarginLeft + ' ' + styles.imgMarginTop;
              break;
            case 5:
              currentClassName = styles.img + ' ' + styles.imgSize + ' ' + styles.imgMarginLeft + ' ' + styles.imgMarginTop;
              break;
            default:
              break;
          }
          secondImgs.push(_react2.default.createElement(
            'span',
            { key: 'secondImgs' + index, onClick: function onClick() {
                return _this2.onSecondItemClick(currentItem);
              },
              className: currentClassName },
            _react2.default.createElement('img', { src: currentItem.img, alt: '' })
          ));
        } else if (index === 6) {
          thirdItemArray.push(_react2.default.createElement(
            'li',
            { key: 'thirdItemArray' + index, onClick: function onClick() {
                return _this2.onSecondItemClick(currentItem);
              },
              className: styles.thirdItemLi, style: { paddingRight: 6 } },
            _react2.default.createElement('img', {
              src: currentItem.img })
          ));
        }
        if (index < 10 && index > 6) {
          thirdItemArray.push(_react2.default.createElement(
            'li',
            { key: 'thirdItemArray' + index, onClick: function onClick() {
                return _this2.onSecondItemClick(currentItem);
              },
              className: styles.thirdItemLi, style: { paddingRight: index === 9 ? 0 : 7 } },
            _react2.default.createElement('img', {
              src: currentItem.img })
          ));
        } else if (index === 10) {
          leftDiv = _react2.default.createElement(
            'span',
            { onClick: function onClick() {
                return _this2.onSecondItemClick(currentItem);
              }, className: styles.leftBig },
            _react2.default.createElement('img', {
              src: currentItem.img, alt: '' })
          );
        }
      });
      return _react2.default.createElement(
        'section',
        { className: secondSectionClassName },
        leftDiv,
        _react2.default.createElement(
          'div',
          { className: styles.rightBig },
          secondImgs,
          _react2.default.createElement('div', { className: 'clear' })
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.thirdItem, style: { height: 123, marginTop: 6 } },
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            'div',
            { style: { width: '100%', height: 123 } },
            _react2.default.createElement(
              'ul',
              null,
              thirdItemArray
            )
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }, {
    key: 'analysisSecondConstDiv0703',
    value: function analysisSecondConstDiv0703(isOpened, secondSectionClassName) {
      var _this3 = this;

      var secondLevel = this.state.middleFilterSecondLevel;
      var styles = require('./ListPageFilterBar.scss');
      return _react2.default.createElement(
        'section',
        { className: secondSectionClassName },
        _react2.default.createElement(
          'div',
          { className: styles.ding_img },
          _react2.default.createElement(_HoverComponent2.default, { onItemClick: this.onSecondItemClick.bind(this), data: secondLevel[0] })
        ),
        _react2.default.createElement(
          'ul',
          { className: styles.ding_ul },
          secondLevel.map(function (currentItem, index) {
            var returnResult = '';
            if (index > 0) {
              returnResult = _react2.default.createElement(
                'li',
                { key: index, className: index < 6 ? styles.mb : '' },
                _react2.default.createElement(_HoverComponent2.default, { onItemClick: _this3.onSecondItemClick.bind(_this3), data: currentItem })
              );
            }
            return returnResult;
          })
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }, {
    key: 'analysisFourthOtherDiv',
    value: function analysisFourthOtherDiv(fourthSectionClassName) {
      var _this4 = this;

      var styles = require('./ListPageFilterBar.scss');
      var bigImgUrl = '';
      var bottomImgs = [];
      var selectedSecondItemId = this.props.selectedSecondItemId;

      var fourthLevel = this.state.middleFilterFourthLevel;
      /* const {selectedSecondItemId
       // , fourthItemBottomItemsFlipInfo
       } = this.state;*/
      fourthLevel.forEach(function (item) {
        if (item.parentId === selectedSecondItemId) {
          bigImgUrl = item.topImg;
          if (item.bottomItems instanceof Array) {
            item.bottomItems.forEach(function (bottomItem, index) {
              bottomImgs.push(_react2.default.createElement(
                'li',
                { key: 'bottomImgs' + index },
                _react2.default.createElement(
                  'i',
                  { className: styles.front },
                  _react2.default.createElement('img', { src: bottomItem.front, alt: '' })
                )
              ));
            });
          }
        }
      });
      return _react2.default.createElement(
        'section',
        { className: fourthSectionClassName },
        _react2.default.createElement(
          'div',
          { className: styles.fourthItemTopImg },
          _react2.default.createElement('img', { src: bigImgUrl, alt: '' })
        ),
        _react2.default.createElement(
          'span',
          { className: styles.fourthItemBackImg, onClick: function onClick() {
              return _this4.fourthBackBtnClick();
            } },
          _react2.default.createElement('img', {
            src: 'http://tupian.goeasy.cn:9999/yipinwang/third/shxx_back.png', alt: '' })
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.fourthItemTopImg + ' ' + styles.fourthMarginTop },
          _react2.default.createElement('div', { className: styles.fourthItemLine + ' ' + styles.fourthMarginLeft }),
          _react2.default.createElement(
            'div',
            { className: styles.fourthItemBottom },
            _react2.default.createElement(
              'ul',
              null,
              bottomImgs
            )
          ),
          _react2.default.createElement('div', { className: styles.fourthItemLine })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./ListPageFilterBar.scss');
      var secondItemMoreBtnClick = this.state.secondItemMoreBtnClick;
      var selectedSecondItemId = this.props.selectedSecondItemId;

      var secondSectionClassName = styles.animated + ' ' + styles.itemActived;
      var fourthSectionClassName = styles.animated;
      var isOpened = true;
      if (secondItemMoreBtnClick) {
        isOpened = true;
      }
      if (selectedSecondItemId) {
        fourthSectionClassName = styles.animated + ' ' + styles.itemActived + ' ' + styles.fadeInRightBig;
        secondSectionClassName = styles.animated;
      } else {
        secondSectionClassName = styles.animated + ' ' + styles.itemActived;
        fourthSectionClassName = styles.animated;
      }

      return _react2.default.createElement(
        'div',
        { className: styles.component },
        this.analysisSecondConstDiv0703(isOpened, secondSectionClassName),
        this.analysisFourthOtherDiv(fourthSectionClassName)
      );
    }
  }]);
  return ListPageFilterBar;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.array,
  firstLevel: _react.PropTypes.array,
  secondLevel: _react.PropTypes.array,
  fourthLevel: _react.PropTypes.array,
  selectedFirstItemId: _react.PropTypes.string,
  selectedSecondItemId: _react.PropTypes.string,
  onChangeSelectedFirstItemId: _react.PropTypes.func,
  onChangeSelectedSecondItemId: _react.PropTypes.func,
  firstItemClick: _react.PropTypes.func,
  changeShownOfBelow: _react.PropTypes.func,
  secondItemClick: _react.PropTypes.func,
  firstConstItemClick: _react.PropTypes.func,
  onFourthConstBackBtnClick: _react.PropTypes.func
}, _temp);
exports.default = ListPageFilterBar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ListPageFilterBar/NewListPageFilterBar.js
 ** module id = 1362
 ** module chunks = 0
 **/